export default __webpack_public_path__ + "static/media/comic1_Panel1.21629751.png";